// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"e696bb8b","191":"e5bc5e13","226":"9a0e0e90","239":"14a6e671","247":"01e2896a","319":"b167f2dd","455":"94a74796","977":"b4fb17cd"}[chunkId] + ".chunk.js";
};